// Valid Time Formats are: HH:mm or HH
// The first check is for when we are backspacing from HH:m, HH: must be valid at that point
export const isValidTimeFormat = (time) => {
    const hoursAndMinutesRegex = /^\d{0,2}?\:\d{0,2}$/;
    const hoursOnlyRegex = /^\d{0,2}?$/;
    return hoursAndMinutesRegex.test(time) || hoursOnlyRegex.test(time);
};
// Completed time format is HH:mm OR empty string
export const isCompletedTimeFormat = (time) => {
    const timeRegex = /^\d{2}\:\d{2}$/;
    return timeRegex.test(time);
};
export const isValidTime = (time) => {
    if (!time) {
        return true;
    }
    if (!isCompletedTimeFormat(time)) {
        return false;
    }
    const [hrStr, minStr] = time.split(':');
    // Check if hours is not between 0 and 24
    if (hrStr && hrStr.length && (parseInt(hrStr, 10) < 0 || parseInt(hrStr, 10) > 23)) {
        return false;
    }
    // Check if minutes is not between 0 and 59
    if (minStr && minStr.length && (parseInt(minStr, 10) < 0 || parseInt(minStr, 10) > 59)) {
        return false;
    }
    return true;
};
//# sourceMappingURL=helper.js.map